export enum Device {
	L = 1,
	XL = 2,
	XXL = 3,
}

function createElementFromHTML(htmlString) {
	const div = document.createElement('div');
	div.innerHTML = htmlString.trim();

	return div.firstChild ? div.firstChild : div;
}

export default function setupInteractiveOffices() {
	const parent = document.getElementById('interactive-offices');

	if (!parent) {
		console.info(
			`An element with id 'interactive-offices' was not found. Interactive offices two was not initialized.`,
		);
		return;
	}

	const offices = Array.prototype.slice.call(parent.getElementsByClassName('roc-interactive-office__box'));

	const xxlOffices = document.createElement('div');
	xxlOffices.classList.add('roc-interactive-office__list-xxl');

	const xlOffices = document.createElement('div');
	xlOffices.classList.add('roc-interactive-office__list-xl');

	const lOffices = document.createElement('div');
	lOffices.classList.add('roc-interactive-office__list-l');

	for (let x = 0; x < offices.length; x++) {
		createOffice(offices[x], parent, x, xxlOffices, Device.XXL);
	}

	for (let x = 0; x < offices.length; x++) {
		createOffice(offices[x], parent, x, xlOffices, Device.XL);
	}

	for (let x = 0; x < offices.length; x++) {
		createOffice(offices[x], parent, x, lOffices, Device.L);
	}

	parent.appendChild(xxlOffices);
	parent.appendChild(xlOffices);
	parent.appendChild(lOffices);

	const originalList = document.getElementsByClassName('roc-interactive-office__original-list')[0];

	if (!originalList) {
		console.error('Original list with class "roc-interactive-office__original-list" was not found. Please add.');
		return;
	}

	originalList.remove();
}

function createOffice(office, parent, x, appendDiv, device) {
	const officeToggleXElement = createElementFromHTML(
		'<svg class="roc-interactive-office__box-toggle-x" focusable="false"><use xlink:href="#icon-x"></use></svg>',
	);

	const officeToggleTriangle = createElementFromHTML(
		'<svg class="roc-interactive-office__box-toggle-triangle"><use xlink:href="#icon-chevron-hot-spot"></use></svg>',
	);

	const officeToggleMessageClose = createElementFromHTML(
		'<span class="roc-visually-hidden roc-interactive-office__box-toggle-msg-close">Close.</span>',
	);

	const officeIconRightTriangle = createElementFromHTML(
		'<svg class="roc-interactive-office__box-right-triangle"><use xlink:href="#icon-chevron-hot-spot"></use></svg>',
	);

	const mainImage = Array.prototype.slice.call(parent.getElementsByClassName('roc-interactive-office__image'))[0];

	if (!mainImage) {
		console.error(
			`A main image with class 'roc-interactive-office__image' was not found. Interactive offices two was not initialized.`,
		);
		return;
	}

	const officeText = office.dataset.text;

	if (!officeText) {
		console.error(`Office #${x + 1}'s text was not found. Please add and try again.`);
		return;
	}

	const officeSubtext = office.dataset.subtext;

	if (!officeSubtext) {
		console.warn(`Office #${x + 1}'s subtext was not found.`);
	}

	const officeLink = office.dataset.link;

	if (!officeLink) {
		console.error(`Office #${x + 1}'s link was not found. Please add and try again.`);
		return;
	}

	const officeAccessibilityText = office.dataset.accessibilityText;

	if (!officeAccessibilityText) {
		console.error(`Office #${x + 1}'s accessibility text was not found. Please add and try again.`);
		return;
	}

	const officeAccessibilityTextElement = document.createElement('span');
	officeAccessibilityTextElement.classList.add('roc-visually-hidden');
	officeAccessibilityTextElement.classList.add('roc-interactive-office__box-toggle-msg-open');
	officeAccessibilityTextElement.innerHTML = officeAccessibilityText;

	const officeIcon: SVGElement = Array.prototype.slice.call(
		office.getElementsByClassName('roc-interactive-office__box-toggle-image'),
	)[0];

	if (!officeIcon) {
		console.error(`Office #${x + 1}'s main SVG icon was not found. Please add and try again.`);
		return;
	}

	const officeIconClone = officeIcon.cloneNode(true);

	const officeButton = document.createElement('button');
	officeButton.classList.add('roc-interactive-office__box-toggle');
	officeButton.setAttribute('type', 'button');
	officeButton.setAttribute('aria-expanded', 'false');

	officeButton.appendChild(officeToggleXElement);
	officeButton.appendChild(officeIconClone);
	officeButton.appendChild(officeToggleTriangle);
	officeButton.appendChild(officeAccessibilityTextElement);
	officeButton.appendChild(officeToggleMessageClose);

	const officeBody = document.createElement('div');
	officeBody.classList.add('roc-interactive-office__box-body');

	officeBody.appendChild(officeButton);

	const officeContentIcon = <HTMLElement>officeIcon.cloneNode(true);
	officeContentIcon.classList.remove('roc-interactive-office__box-toggle-image');
	officeContentIcon.classList.add('roc-interactive-office__box-content-text-image');

	const officeBoxContentText = document.createElement('div');
	officeBoxContentText.classList.add('roc-interactive-office__box-content-text');

	const officeBoxContentTitle = document.createElement('h2');
	officeBoxContentTitle.classList.add('roc-interactive-office__box-content-title');
	officeBoxContentTitle.innerHTML = officeText;

	const officeBoxContentLink = document.createElement('a');
	officeBoxContentLink.setAttribute('href', officeLink);
	officeBoxContentLink.classList.add('roc-interactive-office__box-content-cta');
	officeBoxContentLink.innerHTML =
		'<span class="roc-interactive-office__box-content-cta-wrapper"><span class="roc-interactive-office__box-content-cta-text">Shop Now</span><svg class="roc-icon roc-interactive-office__box-content-cta-arrow"><use xlink:href="#icon-arrow-right"></use></svg></span>';

	officeBoxContentText.appendChild(officeBoxContentTitle);

	if (officeSubtext) {
		const officeBoxContentSubtext = document.createElement('p');
		officeBoxContentSubtext.classList.add('roc-interactive-office__box-content-subtext');
		officeBoxContentSubtext.innerHTML = officeSubtext;
		officeBoxContentText.appendChild(officeBoxContentSubtext);
	}

	officeBoxContentText.appendChild(officeBoxContentLink);

	const officeBoxContent = document.createElement('div');
	officeBoxContent.classList.add('roc-interactive-office__box-content');

	officeBoxContent.appendChild(officeContentIcon);
	officeBoxContent.appendChild(officeBoxContentText);

	officeBody.appendChild(officeBoxContent);

	const officeParent = document.createElement('div');
	officeParent.classList.add('roc-interactive-office__box');

	let officeXCoordinate;
	let officeXOpenCoordinate;
	let officeYCoordinate;
	let officeSize;

	if (device === Device.XXL) {
		officeXCoordinate = office.dataset.positionXXxl;
		officeXOpenCoordinate = office.dataset.positionXXxlOpen;
		officeYCoordinate = office.dataset.positionYXxl;
		officeSize = 'XXL';
	} else if (device === Device.XL) {
		officeXCoordinate = office.dataset.positionXXl;
		officeXOpenCoordinate = office.dataset.positionXXlOpen;
		officeYCoordinate = office.dataset.positionYXl;
		officeSize = 'XL';
	} else {
		officeXCoordinate = office.dataset.positionXL;
		officeXOpenCoordinate = office.dataset.positionXLOpen;
		officeYCoordinate = office.dataset.positionYL;
		officeSize = 'L';
	}

	if (!officeXCoordinate) {
		console.error(`${officeSize} office #${x + 1}'s x coordinate was not found. Please add and try again.`);
		return;
	}

	if (!officeYCoordinate) {
		console.error(`${officeSize} office #${x + 1}'s y coordinate was not found. Please add and try again.`);
		return;
	}

	officeParent.style.left = officeXCoordinate;
	officeParent.style.top = officeYCoordinate;

	officeParent.appendChild(officeBody);
	officeParent.appendChild(officeIconRightTriangle);

	officeButton.addEventListener('click', () => {
		if (officeParent.classList.contains('roc-interactive-office__box--open')) {
			closeBox(officeParent, officeButton, office, officeXCoordinate, officeBoxContentText);
		} else {
			openBox(officeParent, officeButton, office, officeBoxContentText, officeXOpenCoordinate);
		}
	});

	document.addEventListener('click', function (event) {
		const isClickInside = officeParent?.contains(event.target as Node);

		if (!isClickInside) {
			closeBox(officeParent, officeButton, office, officeXCoordinate, officeBoxContentText);
		}
	});

	appendDiv.appendChild(officeParent);
}

function openBox(officeParent, officeButton, office, officeBoxContentText, officeXOpen) {
	officeParent.classList.add('roc-interactive-office__box--open');
	officeButton.setAttribute('aria-expanded', 'true');

	if (officeXOpen) {
		officeParent.style.left = officeXOpen;
	}

	officeBoxContentText.classList.add('roc-interactive-office__box-content-text--shown');

	setTimeout(() => {
		officeBoxContentText.classList.add('roc-interactive-office__box-content-text--animate');
	}, 25);
}

function closeBox(officeParent, officeButton, office, officeX, officeBoxContentText) {
	officeParent.classList.remove('roc-interactive-office__box--open');
	officeButton.setAttribute('aria-expanded', 'false');

	if (office.dataset.positionXXxlOpen) {
		officeParent.style.left = officeX;
	}

	officeBoxContentText.classList.remove('roc-interactive-office__box-content-text--shown');
	officeBoxContentText.classList.remove('roc-interactive-office__box-content-text--animate');
}
